import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  title: {
    margin: '0 0 12px 0',
    fontSize: 28,
    fontWeight: 'bold',
    color: '#7833FF',
    textAlign: 'center',
  },
  subtitle: {
    fontSize: 14,
    color: '#757575',
    margin: '0 0 30px 0',
    textAlign: 'center',
    lineHeight: '1.5rem',

    '& a': {
      color: '#757575',
    },
  },
  itemContainer: {
    marginTop: 0,
    marginBottom: 0,
  },
  item: {
    textAlign: 'center',

    '& img': {
      height: 75,
    },
  },
  titleOptions: {
    color: '#7833FF',
    fontSize: 24,
    fontWeight: 'Bold',
    fontFamily: 'Lato',
    marginTop: 17,
  },
  textOptions: {
    fontFamily: 'Lato',
    fontSize: 16,
    lineHeight: 1.3,
    marginTop: 17,
  },
}));
